import React, { useEffect, useState } from 'react';
export function CountdownTimer() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 2,
    minutes: 0,
    seconds: 0
  });
  const [isExpired, setIsExpired] = useState(false);
  useEffect(() => {
    const endTimeStr = localStorage.getItem('salud_oferta_end');
    let endTime: number;
    if (!endTimeStr) {
      // Set to 2 hours from now
      endTime = new Date().getTime() + 2 * 60 * 60 * 1000;
      localStorage.setItem('salud_oferta_end', endTime.toString());
    } else {
      endTime = parseInt(endTimeStr, 10);
    }
    const interval = setInterval(() => {
      const now = new Date().getTime();
      const distance = endTime - now;
      if (distance < 0) {
        clearInterval(interval);
        setIsExpired(true);
      } else {
        setTimeLeft({
          hours: Math.floor(distance % (1000 * 60 * 60 * 24) / (1000 * 60 * 60)),
          minutes: Math.floor(distance % (1000 * 60 * 60) / (1000 * 60)),
          seconds: Math.floor(distance % (1000 * 60) / 1000)
        });
      }
    }, 1000);
    return () => clearInterval(interval);
  }, []);
  if (isExpired) {
    return <div className="text-red-400 font-poppins font-bold text-2xl animate-pulse text-center" data-id="element-37">
        ¡OFERTA EXPIRADA!
      </div>;
  }
  const formatNumber = (num: number) => num.toString().padStart(2, '0');
  return <div className="flex items-center justify-center gap-3 md:gap-5 my-6" data-id="element-38">
      <div className="flex flex-col items-center" data-id="element-39">
        <div className="bg-white text-brand-accent font-poppins font-bold text-3xl md:text-4xl p-3 md:p-4 rounded-xl border border-green-200 w-16 md:w-20 text-center shadow-lg" data-id="element-40">
          {formatNumber(timeLeft.hours)}
        </div>
        <span className="text-xs md:text-sm text-green-100 mt-2 uppercase font-bold tracking-wider" data-id="element-41">
          Horas
        </span>
      </div>
      <span className="text-2xl md:text-4xl font-bold text-green-300 pb-8" data-id="element-42">
        :
      </span>
      <div className="flex flex-col items-center" data-id="element-43">
        <div className="bg-white text-brand-accent font-poppins font-bold text-3xl md:text-4xl p-3 md:p-4 rounded-xl border border-green-200 w-16 md:w-20 text-center shadow-lg" data-id="element-44">
          {formatNumber(timeLeft.minutes)}
        </div>
        <span className="text-xs md:text-sm text-green-100 mt-2 uppercase font-bold tracking-wider" data-id="element-45">
          Minutos
        </span>
      </div>
      <span className="text-2xl md:text-4xl font-bold text-green-300 pb-8" data-id="element-46">
        :
      </span>
      <div className="flex flex-col items-center" data-id="element-47">
        <div className="bg-white text-brand-accent font-poppins font-bold text-3xl md:text-4xl p-3 md:p-4 rounded-xl border border-green-200 w-16 md:w-20 text-center shadow-lg" data-id="element-48">
          {formatNumber(timeLeft.seconds)}
        </div>
        <span className="text-xs md:text-sm text-green-100 mt-2 uppercase font-bold tracking-wider" data-id="element-49">
          Segundos
        </span>
      </div>
    </div>;
}